import {Injectable} from "@angular/core";
import {firstValueFrom, from, Observable} from "rxjs";
import {take} from "rxjs/operators";
import {CartQuantityNotifier} from "../domain/cart-quantity-notifier";
import {CartLineRepository} from "./cart-line-repository.service";

/**
 * Use case for clearing all items from the shopping cart.
 */
@Injectable({
    providedIn: "root",
})
export class ClearCartUseCase {
    constructor(
        private cartLineRepository: CartLineRepository,
        private cartQuantityNotifier: CartQuantityNotifier
    ) { }

    /**
     * Clears all items from the shopping cart.
     * Optionally triggers notifications about the updated cart quantity.
     *
     * @param notifyChange Indicates whether to notify observers of the cart quantity change (defaults to true).
     * @returns An Observable that completes once the cart is cleared (and notifications, if enabled, are sent).
     */
    execute(notifyChange: boolean = true): Observable<void> {
        return from(this.clearCart(notifyChange));
    }

    private async clearCart(notifyChange: boolean) {
        await firstValueFrom(this.cartLineRepository.clearAllCartLines().pipe(take(1)));
        if (notifyChange) {
            await this.cartQuantityNotifier.notifyCartQuantityChanged();
        }
    }
}
